<template>
  <div v-bind:id="dataId" ref="radial"></div>
</template>

<script>

  import 'd3';
  import RadialProgressChart from 'radial-progress-chart'
  

  export default {
    name: "radial-progress",
    props: {
      mode: {
        type: String,
        default: 'normal'
      },
      dataId: {
        type: String
      },
      color: {
        type: String,
        default: 'red'
      },
      outOfValue: {
        type: Number,
        default: 0
      },
      value: {
        type: Number,
        default: 0
      },
      suffix: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        rb: 'undefined'
      }
    },
    mounted() {
      let self = this;
      if (self.mode === 'normal') {
        self.rb = new RadialProgressChart('#' + self.dataId, {
          stroke: {
            width: 8,
            gap: 2
          },
          shadow: {
            width: 0
          },
          diameter: 200,
          max: 100,
          round: false,
          series: [{

            value: self.value,
            color: self.color
          }],
          center: function (d) {
            return d.toFixed(0) + self.suffix;
          }
        });

      }
      if (self.mode === 'outOf') {
        self.rb = new RadialProgressChart('#' + self.dataId, {
          stroke: {
            width: 3,
            gap: 0
          },
          shadow: {
            width: 0
          },
          diameter: 190,
          max: self.outOfValue,
          round: true,
          series: [{

            value: self.value,
            color: self.color
          }],
          center: {
            content: [function (value) {
              return value + self.suffix
            }, ' OF ' + self.outOfValue + self.suffix],
            y: 15
          }
        });
      }

      if (self.mode === 'duration') {
        let outOf;
        moment.relativeTimeThreshold('m', 60);
        moment.relativeTimeThreshold('s', 60);
        let start = moment();
        let end = moment();
        end.add(self.outOfValue, 'minutes');
        let diff = end.diff(start);
        let object = moment.utc(diff).toObject();
        if (object.hours === 0) {
          outOf = moment.duration(object.minutes, 'minutes').format('m _');
        }
        outOf = moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _')
        self.rb = new RadialProgressChart('#' + self.dataId, {
          stroke: {
            width: 3,
            gap: 0
          },
          shadow: {
            width: 0
          },
          diameter: 300,
           max: self.outOfValue,
          round: true,
          series: [{
            value: self.value,
            color: self.color
          }],
          center: {
            content: [function (value) {
              let outOf;
              moment.relativeTimeThreshold('m', 60);
              moment.relativeTimeThreshold('s', 60);
              let start = moment();
              let end = moment();
              end.add(value, 'minutes');
              let diff = end.diff(start);
              let object = moment.utc(diff).toObject();
              if (object.hours === 0) {
                outOf = moment.duration(object.minutes, 'minutes').format('m _');
                return moment.duration(object.minutes, 'minutes').format('m _');
              }
              else {
                outOf = moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _')
              }
              return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _')
            }, ' OF ' + outOf],
            y: 15
          }
        });
      }


    }
  }
</script>
<style>
  tspan.rbc-center-text-line0 {
    font-size: 48px !important;
  }
</style>



// WEBPACK FOOTER //
// RadialProgress.vue?1d564bf6